import {
  abs,
  cameraPosition,
  cameraProjectionMatrix,
  cameraViewMatrix,
  dot,
  Fn,
  length,
  max,
  normalize,
  normalWorld,
  positionWorld,
  smoothstep,
  vec2,
  vec4,
} from "three/tsl"
import * as THREE from "three/webgpu"

export const circleMask = Fn(
  ({
    coordsNDC,
    radiusNDC,
  }: {
    coordsNDC: THREE.UniformNode<THREE.Vector2>
    radiusNDC: THREE.UniformNode<number>
  }) => {
    const worldPos4 = vec4(positionWorld, 1)
    const viewPos4 = cameraViewMatrix.mul(worldPos4)
    const clipPos4 = cameraProjectionMatrix.mul(viewPos4)
    const fragScreen = vec2(
      clipPos4.x.div(clipPos4.w),
      clipPos4.y.div(clipPos4.w),
    )

    const toCamera = normalize(cameraPosition.sub(positionWorld))
    const surfaceToCamera = dot(toCamera, normalWorld)
    const viewAngle = max(0.3, abs(surfaceToCamera))

    // Calculate distance in screen space (NDC coordinates)
    const screenDist = length(fragScreen.sub(coordsNDC))

    // When surface faces camera, use direct distance
    // When edge-on, the circle appears smaller (divide by viewing angle)
    const surfaceDistance = screenDist.div(viewAngle)

    // Create circular mask with smooth edges
    const circleInner = radiusNDC.mul(0.1)
    const circleOuter = radiusNDC

    return smoothstep(circleOuter, circleInner, surfaceDistance)
  },
)
